import { log } from 'consoleManager';
import { SESSION_STORAGE_TYPE, SESSION_KEY_STORAGE_TYPE } from 'src/utils/enum';
import { getAppSessionId } from 'src/utils';

const initStoreData = (mainStorageKey, keyName) => {
  const keyNameExist = localStorage.getItem(keyName);
  if (!keyNameExist) {
    localStorage.setItem(keyName, JSON.stringify([]));
    handleAllStoreKeys(mainStorageKey, keyName);
  }
};

const getStoreData = (keyName) => {
  try {
    const storeData = localStorage.getItem(keyName);
    return storeData ? JSON.parse(storeData) : [];
  } catch (e) {
    log(e);
    return [];
  }
};

/**
 * It takes a key and a value, and then it sets the value of the key in localStorage
 * @param key - The key to store the data under.
 * @param value - The value to be stored.
 * @returns after update data return true.
 */
const updateStoreData = (keyName, objData) => {
  try {
    localStorage.setItem(keyName, JSON.stringify(objData));
  } catch {
    // if (e.name === 'QuotaExceededError') {
    updateLocalStorageGetError(keyName, objData);
    //}
  }
};

/**
 * if get QuotaExceededError error from storage then use this method
 */
const updateLocalStorageGetError = (keyName, objData) => {
  removeBatchDataOverflowStorage();
  removePriorityDataOverflowStorage();
  const prioritySessionId = SESSION_STORAGE_TYPE.priority + getAppSessionId();
  const batchedSessionId = SESSION_STORAGE_TYPE.batched + getAppSessionId();
  let priorityMainKey = [];
  priorityMainKey.push(prioritySessionId);
  let batchMainKey = [];
  batchMainKey.push(batchedSessionId);
  localStorage.setItem(
    SESSION_KEY_STORAGE_TYPE.priority,
    JSON.stringify(priorityMainKey)
  );
  localStorage.setItem(
    SESSION_KEY_STORAGE_TYPE.batched,
    JSON.stringify(batchMainKey)
  );
  localStorage.setItem(keyName, JSON.stringify(objData));
};

/**
 * when local storage limit full use this method to remove batch data from storage
 */
const removeBatchDataOverflowStorage = () => {
  try {
    const analyticsKeyList = getKeyNameStoreData(
      SESSION_KEY_STORAGE_TYPE.batched
    );
    const analyticsKeyListArr = JSON.parse(analyticsKeyList);
    if (Array.isArray(analyticsKeyListArr) && analyticsKeyListArr.length > 0) {
      analyticsKeyListArr.forEach((key) => {
        localStorage.removeItem(key);
      });
    }
    localStorage.removeItem(SESSION_KEY_STORAGE_TYPE.batched);
  } catch {
    // get error
  }
};

/**
 * when local storage limit full use this method to remove priority data from storage
 */
const removePriorityDataOverflowStorage = () => {
  try {
    const analyticsKeyList = getKeyNameStoreData(
      SESSION_KEY_STORAGE_TYPE.priority
    );
    const analyticsKeyListArr = JSON.parse(analyticsKeyList);
    if (Array.isArray(analyticsKeyListArr) && analyticsKeyListArr.length > 0) {
      analyticsKeyListArr.forEach((key) => {
        localStorage.removeItem(key);
      });
    }
    localStorage.removeItem(SESSION_KEY_STORAGE_TYPE.priority);
  } catch {
    // get error
  }
};

/**
 * It removes the data from the local storage.
 * @param key - The key to remove from localStorage.
 */
const removeStoreData = (keyName) => {
  localStorage.removeItem(keyName);
};

const checkStoreData = (mainStorageKey, keyName) => {
  try {
    const sessionKeyExist = localStorage.getItem(keyName);
    if (sessionKeyExist === null) {
      initStoreData(mainStorageKey, keyName);
      return getStoreData(keyName);
    } else {
      return getStoreData(keyName);
    }
  } catch (e) {
    log(e);
  }
};

const handleAllStoreKeys = (mainStorageKey, currentStorageKey) => {
  try {
    if (!localStorage.getItem(mainStorageKey)) {
      localStorage.setItem(mainStorageKey, JSON.stringify([]));
    }
    const allStorageKeysStr = localStorage.getItem(mainStorageKey);
    let allStorageKeys = [];
    allStorageKeys = allStorageKeysStr ? JSON.parse(allStorageKeysStr) : [];
    if (allStorageKeys.indexOf(currentStorageKey) == -1) {
      allStorageKeys.push(currentStorageKey);
    }
    localStorage.setItem(mainStorageKey, JSON.stringify(allStorageKeys));
  } catch (e) {
    log(e);
  }
};

const getKeyNameStoreData = (keyName) => {
  const storeData = localStorage.getItem(keyName);
  return storeData;
};

export {
  initStoreData,
  getStoreData,
  updateStoreData,
  removeStoreData,
  checkStoreData,
  handleAllStoreKeys,
  getKeyNameStoreData,
};
